/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum TextStyleFlags {
  BOLD = 1,
  ITALIC = 2,
  UNDERLINE = 4,
  STRIKETHROUGH = 8,
}
